

function FilterByPlaceEventTable(location, trainingListCount) {

    var filterTitle = document.getElementById("trainingDropdownMenuButton").innerText;

    if (filterTitle.trim() != "Alle Fortbildungen") {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-event-table__eventList-eventItem-Place-" + i).innerText.includes(location.trim()) && document.getElementById("don-event-table__eventList-eventItem-Title-" + i).innerText.includes(filterTitle.trim())) {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "";
            }
            else {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "none";
                
            }
        }
    }
    else {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-event-table__eventList-eventItem-Place-" + i).innerText.includes(location.trim())) {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "";
            }
            else {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "none";
            }
        }
    }

    document.getElementById("locationDropdownMenuButton").innerText = location;
}

function FilterByTitleEventTable(title, trainingListCount) {

    var filterLocation = document.getElementById("locationDropdownMenuButton").innerText;

    if (filterLocation.trim() != "Alle Orte") {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-event-table__eventList-eventItem-Title-" + i).innerText.trim() == title.trim() && document.getElementById("don-event-table__eventList-eventItem-Place-" + i).innerText.trim() == filterLocation.trim()) {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "";
            }
            else {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "none";
            }
        }
    }
    else {
        for (var i = 0; i < trainingListCount; i++) {
            if (document.getElementById("don-event-table__eventList-eventItem-Title-" + i).innerText.trim() == title.trim()) {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "";
            }
            else {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "none";
            }
        }
    }

    document.getElementById("trainingDropdownMenuButton").innerText = title;
}

function RemoveFilterEventTable(objectType, trainingListCount) {

    if (objectType == 'location') {
        document.getElementById("locationDropdownMenuButton").innerText = "Alle Orte";

        var filterTitle = document.getElementById("trainingDropdownMenuButton").innerText;
        if (filterTitle != "Alle Fortbildungen") {
            FilterByTitleEventTable(filterTitle, trainingListCount);
        }
        else {
            for (var i = 0; i < trainingListCount; i++) {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "";
            }
        }
    }
    else if (objectType == 'training') {
        document.getElementById("trainingDropdownMenuButton").innerText = "Alle Fortbildungen";

        var filterLocation = document.getElementById("locationDropdownMenuButton").innerText;
        if (filterLocation != "Alle Orte") {
            FilterByPlaceEventTable(filterLocation, trainingListCount);
        }
        else {
            for (var i = 0; i < trainingListCount; i++) {
                document.getElementById("don-event-table__eventList-eventItem-" + i).style.display = "";
            }
        }
    }
}